export enum UnemploymentStepIdentifier {
  Registration,
  Profiling,
  Pricing,
  Contractualization,
  SignedContract
}

export enum BorrowerStepIdentifier {
  Project,
  Pricing,
  Contractualization
}

export enum UPIStepIdentifier {
  Registration,
  RealEstateRegistration,
  Pricing,
  Contractualization,
  SignedContract
}

export enum RGIStepIdentifier {
  Registration,
  RealEstateRegistration,
  TenantRegistration,
  Pricing,
  Contractualization,
  SignedContract,
}

export enum MriStepIdentifier {
  Registration,
  CopropertyRegistration,
  CopropertySurvey,
  CopropertyBuildings,
  CopropertyComplements,
  CopropertyClaims,
  Pricing,
  Contractualization,
  SignedContract
}

export enum LegalProtectionStepIdentifier {
  Registration,
  Eligibility,
  Pricing,
  Contractualization,
  SignedContract
}

export type StepIdentifier = UnemploymentStepIdentifier | BorrowerStepIdentifier | UPIStepIdentifier | RGIStepIdentifier | MriStepIdentifier | LegalProtectionStepIdentifier
